import { graphql } from "@apollo/client/react/hoc";
import { gql } from "@apollo/client";
import { flow } from "lodash";

import { addAuthVars } from "@teamrota/authlib";

import { withAuth } from "~/src/auth/hoc";
import { handleErrors } from "~/src/utils/errors";

import LogFragment from "~/src/graphql/fragments/log/log.fragment";

export const GET_TIMESHEET_MEMBER = addAuthVars(gql`
  ${LogFragment}
  query getTimesheetMember($id: ID!) {
    timesheetMemberRow(id: $id) {
      id
      role {
        id
        name
      }
      venue {
        id
        name
      }
      subvenue {
        id
        name
      }
      timesheet {
        id
        accountId
        accountName
        status
        venueId
      }
      breakMinutes
      status
      scheduledStartTime
      scheduledEndTime
      purchaseOrderNumber
      purchaseOrderNumber
      ... on TimesheetMemberRow {
        logs {
          ...LogFragment
        }
      }
    }
  }
`);

export default flow(
  graphql(GET_TIMESHEET_MEMBER, {
    skip: props => !props.isOpen,
    props: handleErrors(({ data: { loading, timesheetMemberRow } }) => ({
      isLoading: loading,
      timesheetMemberRow
    })),
    options: ({ auth, id }) => ({
      fetchPolicy: "network-only",
      variables: auth.addVals(GET_TIMESHEET_MEMBER, { id })
    })
  }),
  withAuth
);
